// Full reload of the app document, through the container when there is one.
//
// The Windows container serves the bundle from a virtual host
// (https://vizcon.local/initContent/client/htdocs/index.html) and offered a
// `reloadContent` bridge method that re-navigates to that path from the native
// side. Preferred when present: it is the container's own definition of "the
// app", and it spends the container's recovery budget (5 per 10 minutes) rather
// than a bare reload. It returns "true"/"false" (accepted/refused) to a
// callback we do not use — the timeout below covers the refused case.
//
// Scope, stated plainly: this helps a page that is alive but broken. A page
// that is dead — a Chromium error page after a failed navigation — has no
// lib.js and therefore no `vizconContainer`, so neither branch of this function
// can run there. Only the container can rescue that document, which is what
// its root-navigation interception is for.
//
// `window.location.reload()` stays as both fallback and backstop. With hash
// routing the document URL keeps its full path (HashRouter pushes "#/route",
// resolved against the document, never against the origin), so a plain reload
// is correct on its own; the bridge is belt-and-braces, not a fix. And an
// unknown method on an older container is a silent no-op, so if the bridge call
// has not navigated within the grace period the page reloads itself — a wedged
// page must never stay wedged because a bridge call went nowhere.
const BRIDGE_GRACE_MS = 1500;

export const reloadApp = (reason = "unspecified") => {
    const fallback = () => {
        try {
            window.location.reload();
        } catch {
            /* nothing left to try */
        }
    };

    let viaBridge = false;
    try {
        if (typeof window.vizconContainer?.nativeCall === "function") {
            window.vizconContainer.nativeCall({ method: "reloadContent", data: { reason } });
            viaBridge = true;
        }
    } catch {
        viaBridge = false;
    }

    if (!viaBridge) {
        fallback();
        return;
    }
    // If the container navigated, the document is gone and this never fires.
    setTimeout(fallback, BRIDGE_GRACE_MS);
};
